module.exports = __webpack_public_path__ + "img/zenvoice-logo.15d0c66e.svg";